export type FormProxyResetProxyModalFunctionType = () => void;

export interface FormProxyResetProxyModalActionType {
  type: '@formProxy/RESET_MODAL';
}

export const resetProxyModal = (): FormProxyResetProxyModalActionType => ({
  type: '@formProxy/RESET_MODAL',
});
